const SearchPageHandler = (product, event, data) => {
    const { metaData = {}, url = '', from = '', to = '', travelDate = '', journeyClass = '', _journeyClass = [],
        _trainType, trainClassSelected = '', railId = '', selectedQuota = '', fareDetails = {}, tripInfo = {} } = data,
        { arrivalInfo = {}, departureInfo = {}, railwayInfo = {} } = tripInfo,
        { arrival_station = '' } = arrivalInfo,
        { departure_station = '' } = departureInfo,
        { number = '' } = railwayInfo,
        fare = fareDetails[`${railId || number}_${selectedQuota}_${trainClassSelected}`],
        { ravail = [] } = fare,
        [price = {}] = ravail,
        { pi = {} } = price,
        { fc = {} } = pi,
        { NF = 0 } = fc,
        { userId, name = '', email = '', mobile = '', balance = 0 } = metaData;

    let finalData = {
        userId: userId, userName: name, userEmail: email, userContact: mobile, walletBalance: balance, urlPath: url, product: product,
        originCode: from, destinationCode: to, journeyDate: travelDate, journeyClass
    }

    switch (event) {
        case 'PageView':
            break;
        case 'JourneyClass':
            finalData = { ...finalData, journeyClass: _journeyClass.join(','), filter: event }
            break;
        case 'TrainType':
            finalData = { ...finalData, trainType: _trainType.join(','), filter: event }
            break;
        case 'CheckAvailability':
            finalData = { ...finalData, class: trainClassSelected, net: NF }
            break;
        case 'Book':
            finalData = { ...finalData, originName: arrival_station, destinationName: departure_station, class: trainClassSelected, net: NF }
            break;
    }
    return finalData;
}

module.exports = { SearchPageHandler }